<template>
    <main class="page page-dashboard">
        <div class="container">
            <PageHeader
                :title="$translate.text('resellers.add')"
            />

            <p>{{ t('resellers.add.explanation') }}</p>

            <form @submit.prevent="submitForm" method="POST">
                <TextInput
                    id="companyName"
                    :value="companyName"
                    name="companyName"
                    @change="companyName = $event"
                    :label="$translate.text('general.company.name')"
                />

                <TextInput
                    id="contactName"
                    :value="contactName"
                    name="contactName"
                    @change="contactName = $event"
                    :label="$translate.text('general.contact.name')"
                />

                <EmailInput
                    id="email"
                    :value="email"
                    name="email"
                    @change="email = $event"
                    :label="$translate.text('general.email')"
                />

                <Select
                    id="country"
                    :value="country"
                    name="country"
                    @change="country = $event"
                    :options="countriesSelectValues"
                    :label="$translate.text('general.address.country')"
                />

<!--                <Select-->
<!--                    id="language"-->
<!--                    :value="language"-->
<!--                    name="language"-->
<!--                    @change="language = $event"-->
<!--                    :options="options"-->
<!--                    :label="$translate.text('locales.preferred_language')"-->
<!--                />-->

                <FormSubmit
                    :routeAfterCancelLink="{ name: 'Admin Resellers' }"
                    :buttonLabel="submittingIsLoading ? $translate.text('general.send_invitation.sending') :  $translate.text('general.send_invitation')"
                    :disabled="submittingIsLoading"
                />
            </form>
        </div>
    </main>
</template>
<script>
import swal from 'sweetalert';
import { get, post } from '@/helpers/http';
import handleError from '@/helpers/error';

import PageHeader from '@/components/PageHeader/PageHeader';
import TextInput from '@/components/Inputs/TextInput';
import EmailInput from '@/components/Inputs/EmailInput';
import Select from '@/components/Inputs/Select';
import FormSubmit from '@/components/Forms/FormSubmit';

export default {
    name: 'AddReseller',

    components: {
        PageHeader,
        TextInput,
        EmailInput,
        Select,
        FormSubmit,
    },

    data() {
        return {
            companyName: '',
            email: '',
            contactName: '',
            country: '',
            language: 'nl_NL',
            options: [
                { label: this.$translate.text('locales.dutch'), value: 'nl_NL' },
                { label: this.$translate.text('locales.english'), value: 'en_EN' },
                { label: this.$translate.text('locales.german'), value: 'de_DE' },
            ],
            submittingIsLoading: false,
            countries: [],
        };
    },

    created() {
        this.getCountries();
    },

    computed: {
        countriesSelectValues() {
            const values = [{ label: this.$translate.text('general.select_option'), value: null, disabled: true }];

            this.countries.forEach(country => {
                values.push({
                    value: parseInt(country.id, 0),
                    label: country.name,
                });
            });

            return values;
        },
    },

    methods: {
        getCountries() {
            get({
                url: `${this.$API_URL}/api/countries`,
            })
                .then((response) => {
                    this.countries = response.data.data;

                    this.country = this.countries[0].id;
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },
        submitForm() {
            this.submittingIsLoading = true;

            post({
                url: `${this.$API_URL}/api/admin/resellers`,
                data: {
                    company_name: this.companyName,
                    contact_name: this.contactName,
                    language: this.language,
                    email: this.email,
                    country_id: this.country,
                },
            })
                .then(() => {
                    this.submittingIsLoading = false;
                    swal({
                        title: this.$translate.text('alert.success'),
                        text: this.$translate.text('alert.title.invitation.send'),
                    }).then(() => {
                        this.resetForm();
                        this.$router.push({ name: 'Admin Resellers' });
                    });
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });

                    this.submittingIsLoading = false;
                });
        },

        resetForm() {
            this.companyName = '';
            this.contactName = '';
            this.language = 'nl_NL';
            this.email = '';
        },
    },
};
</script>
<style lang="scss" scoped>
form {
    padding-top: 32px;

    .form-group + .form-group {
        margin-top: 8px;
    }

    .form-submit {
        margin-top: 8px;
    }
}
</style>
